var _script;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSui = function SvgSui(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128,
    style: {
      fill: "#6fbcf0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6 194.6c12.8 22.2 35.8 35.5 61.4 35.5s48.6-13.3 61.4-35.5c12.8-22.2 12.8-48.7 0-70.9l-54-93.6c-3.3-5.7-11.5-5.7-14.8 0l-54 93.6c-12.9 22.2-12.9 48.7 0 70.9zm46.2-120 11.5-20c1.6-2.8 5.8-2.8 7.4 0l44.3 76.8c8.1 14.1 9.7 30.4 4.6 45.4-.5-2.4-1.3-4.9-2.3-7.4-6.1-15.5-20-27.4-41.2-35.4-14.6-5.5-23.9-13.7-27.6-24.2-4.8-13.6.3-28.4 3.3-35.2zm-19.7 34L80 131.4c-10 17.4-10 38.1 0 55.5s28 27.7 48 27.7c13.3 0 25.7-4.6 35.5-12.7 1.3-3.2 5.2-14.9.3-27-4.5-11.2-15.3-20.1-32.2-26.5-19-7.2-31.4-18.5-36.8-33.5-.7-2.1-1.2-4.2-1.7-6.3z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: 5.8052,
      strokeOpacity: 0
    }
  }), _script || (_script = /*#__PURE__*/React.createElement("script", null)));
};
export default SvgSui;